export const COOKIE_AUTH_USER = 'auth_user'
export const COOKIE_PROFILE_USER = 'profile_user'
export const COOKIE_UPDATED_COOKIES = 'updated_cookies'

// RULES COOKIES
export const COOKIE_ACCOUNT_RULES = 'account_rules'
export const COOKIE_AGENCIES_RULES = 'agencies_rules'
export const COOKIE_APPRAISALS_RULES = 'appraisals_rules'
export const COOKIE_CHAT_RULES = 'chat_rules'
export const COOKIE_CONTACT_RULES = 'contacts_rules'
export const COOKIE_CRM_RULES = 'crm_rules'
export const COOKIE_DASHBOARD_RULES = 'dashboard_rules'
export const COOKIE_DATASHEETS_RULES = 'datasheets_rules'
export const COOKIE_DEVELOPMENTS_DATASHEET_RULES =
  'developments_datasheet_rules'
export const COOKIE_DEVELOPMENTS_RULES = 'developments_rules'
export const COOKIE_LIST_RULES = 'list_rules'
export const COOKIE_PDFS_RULES = 'pdfs_rules'
export const COOKIE_PORTALS_RULES = 'portals_rules'
export const COOKIE_PROFILE_RULES = 'profile_rules'
export const COOKIE_PROPERTIES_RULES = 'properties_rules'
export const COOKIE_SEARCHER_RULES = 'searcher_rules'
export const COOKIE_STORE_RULES = 'store_rules'
export const COOKIE_TRIAL_RULES = 'trial_rules'

// AUTH0 COOKIES
export const COOKIE_ACCESS_TOKEN = 'access_token'
export const COOKIE_EXPIRES_IN = 'expires_in'
export const COOKIE_REFRESH_TOKEN = 'refresh_token'

export const ALL_COOKIES_AUTH = [
  'binary_role', // This cookie is legacy, delete it when possible
  COOKIE_AUTH_USER,
  COOKIE_PROFILE_USER,
  COOKIE_UPDATED_COOKIES,
  COOKIE_ACCOUNT_RULES,
  COOKIE_AGENCIES_RULES,
  COOKIE_APPRAISALS_RULES,
  COOKIE_CHAT_RULES,
  COOKIE_CONTACT_RULES,
  COOKIE_CRM_RULES,
  COOKIE_DASHBOARD_RULES,
  COOKIE_DATASHEETS_RULES,
  COOKIE_DEVELOPMENTS_DATASHEET_RULES,
  COOKIE_DEVELOPMENTS_RULES,
  COOKIE_LIST_RULES,
  COOKIE_PDFS_RULES,
  COOKIE_PORTALS_RULES,
  COOKIE_PROFILE_RULES,
  COOKIE_PROPERTIES_RULES,
  COOKIE_SEARCHER_RULES,
  COOKIE_STORE_RULES,
  COOKIE_TRIAL_RULES,
  COOKIE_ACCESS_TOKEN,
  COOKIE_EXPIRES_IN,
  COOKIE_REFRESH_TOKEN
]
